var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ys-log-management" },
    [
      _c(
        "Card",
        { attrs: { bordered: false, "dis-hover": "" } },
        [
          _c(
            "div",
            { staticClass: "search-wrapper" },
            [
              _c("search-card", {
                attrs: {
                  form: _vm.mainTable.searchForm,
                  "table-load-event": _vm.getYSLogs,
                  "table-search": _vm.mainTable.tableSearch,
                },
                on: { "on-reset": _vm.handleSearchReset },
              }),
            ],
            1
          ),
          _c("Divider"),
          _c(
            "Row",
            { staticClass: "stat-row", attrs: { gutter: 20 } },
            _vm._l(_vm.statistics, function (stat) {
              return _c(
                "Col",
                { key: stat.label, attrs: { xs: 24, sm: 12, md: 6 } },
                [
                  _c(
                    "Card",
                    {
                      staticClass: "stat-card",
                      class: stat.class,
                      attrs: { shadow: "" },
                    },
                    [
                      _c("div", { staticClass: "stat-content" }, [
                        _c(
                          "div",
                          { staticClass: "stat-icon-box" },
                          [
                            _c("Icon", {
                              attrs: { type: stat.icon, size: "24" },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "stat-info" }, [
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(_vm._s(stat.value)),
                          ]),
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v(_vm._s(stat.label)),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c("div", { staticClass: "global-tool-bar" }, [
            _c(
              "div",
              { staticClass: "left-bar" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v("用友同步日志列表"),
                ]),
                _vm.filterCount > 0
                  ? _c(
                      "Tag",
                      {
                        staticClass: "filter-tag",
                        attrs: { color: "primary", checkable: "" },
                        on: { "on-change": _vm.clearAllFilters },
                      },
                      [
                        _vm._v(
                          "\n                    已筛选 " +
                            _vm._s(_vm.filterCount) +
                            " 条 "
                        ),
                        _c("Icon", { attrs: { type: "md-close" } }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right-bar" },
              [
                _c(
                  "Tooltip",
                  { attrs: { content: "刷新数据", placement: "top" } },
                  [
                    _c("Button", {
                      attrs: {
                        type: "primary",
                        ghost: "",
                        shape: "circle",
                        icon: "md-refresh",
                        loading: _vm.mainTable.loading,
                      },
                      on: { click: _vm.refreshData },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("stand-pagination-table", {
                ref: "paginationTable",
                attrs: {
                  columns: _vm.mainTable.columns,
                  data: _vm.mainTable.data,
                  loading: _vm.mainTable.loading,
                  "table-search": _vm.mainTable.tableSearch,
                  "table-load-event": _vm.getYSLogs,
                  autoHeight: true,
                  showPage: true,
                },
                on: { "on-row-click": _vm.handleRowClick },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("YSLogDetailModal", { ref: "ysLogDetailModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }